import { _ } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

// export type MenuItem = {
//   path?: string | string[] | null;
//   command?: () => void;
//   label: string;
//   data?: any;
//   cssClass?: string;
//   icon?: string;
// };

export const menuItems: MenuItem[] = [
  {
    label: 'label.locations',
    routerLink: '/locations/list',
    // expanded: true,
    // items: [
    //   {
    //     label: 'label.search',
    //     routerLink: '/locations/map',
    //     icon: 'fa-regular fa-home',
    //   },
    //   {
    //     label: 'label.search',
    //     routerLink: '/locations/map',
    //   },
    // ],
  },
  {
    label: 'label.search',
    routerLink: '/locations/map',
  },
  /*{
    label: 'label.analysis',
    routerLink: '/analysis',
  },*/
  {
    label: 'label.scoringSchema',
    routerLink: '/scoring-schema',
  },
];

export const menuLabels = _([
  'label.locations',
  'label.search',
  'label.analysis',
  'label.scoringSchema',
]);
